module.exports = __webpack_public_path__ + "img/railing.99c1837b.png";